import api from '@/lib/api';

export interface Plugin {
  id: string;
  plugin_key: string;
  plugin_name: string;
  description: string;
  config_schema: any;
  is_available: boolean;
  created_at: string;
  updated_at: string;
}

export interface OrganizationPlugin extends Plugin {
  organization_plugin_id: string | null;
  organization_id: string | null;
  organization_config: any;
  is_enabled: boolean;
  enabled_at: string | null;
  created_by_id: string | null;
  enabled_by_email: string | null;
  enabled_by_first_name: string | null;
  enabled_by_last_name: string | null;
}

export interface PluginListResponse {
  success: boolean;
  data: {
    plugins: Plugin[];
  };
}

export interface OrganizationPluginListResponse {
  success: boolean;
  data: {
    plugins: OrganizationPlugin[];
  };
}

export interface EnablePluginRequest {
  pluginId: string;
  config?: any;
}

export interface DisablePluginRequest {
  pluginId: string;
}

export interface UpdatePluginConfigRequest {
  pluginId: string;
  config: any;
}

export interface PluginActionResponse {
  success: boolean;
  message: string;
  data: {
    organizationPlugin: any;
  };
}

class PluginsService {
  /**
   * Tüm mevcut plugin'leri getir
   */
  async getPlugins(): Promise<PluginListResponse> {
    const response = await api.get<PluginListResponse>('/plugins');
    return response.data;
  }

  /**
   * Organization için plugin'leri getir
   */
  async getOrganizationPlugins(organizationId: string): Promise<OrganizationPluginListResponse> {
    const response = await api.get<OrganizationPluginListResponse>(`/plugins/organization/${organizationId}`);
    return response.data;
  }

  /**
   * Organization için plugin'i aktifleştir
   */
  async enablePlugin(organizationId: string, data: EnablePluginRequest): Promise<PluginActionResponse> {
    const response = await api.post<PluginActionResponse>(
      `/plugins/organization/${organizationId}/enable`,
      data
    );
    return response.data;
  }

  /**
   * Organization için plugin'i deaktifleştir
   */
  async disablePlugin(organizationId: string, data: DisablePluginRequest): Promise<PluginActionResponse> {
    const response = await api.post<PluginActionResponse>(
      `/plugins/organization/${organizationId}/disable`,
      data
    );
    return response.data;
  }

  /**
   * Organization plugin config'ini güncelle
   */
  async updatePluginConfig(organizationId: string, data: UpdatePluginConfigRequest): Promise<PluginActionResponse> {
    const response = await api.put<PluginActionResponse>(
      `/plugins/organization/${organizationId}/config`,
      data
    );
    return response.data;
  }
}

export default new PluginsService();
